import React from 'react'

import { useStyles } from './NoDataView.styles'
import NoView from '../../../../../common/images/NoView.png'
import { Typography } from '@mui/material'
import { ButtonV2 } from '@labrav/react-components'
import { ListingType } from '../../../../../modules/storefront/listingCardCreation/types'

type NoDataViewProps = {
  navigateToCreate?: () => void
  type?: ListingType
  ButtonText?: string
  title?: string
  subText?: string
}
export const NoDataView: React.FC<NoDataViewProps> = ({
  navigateToCreate,
  ButtonText,
  title,
  subText,
  type,
}) => {
  const { classes } = useStyles()
  navigateToCreate
  return (
    <div className={classes.root}>
      <div>
        <img
          src={NoView}
          data-testid={'no-view'}
          style={{ width: '214px', height: '120px' }}
          alt="now view img"
        />
      </div>
      <div className={classes.subContent}>
        <Typography className={classes.rowTitle}>{title}</Typography>
        <Typography className={classes.lightText}>{subText}</Typography>
        {type && (
          <div>
            <ButtonV2
              onClick={navigateToCreate}
              data-testid="create-button"
              styleType="primary"
              disabled={false}
              smallVariant
            >
              {ButtonText}
            </ButtonV2>
          </div>
        )}
      </div>
    </div>
  )
}
